import {TranslationObject} from '@colonist/i18n'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {PIXI} from '@colonist/pixi'
import {UICanvasConfig} from './UICanvasConfig'
import {ToolTipText} from 'code/client/web/scripts/ui_game/ui_game_tooltip/UIWGameToolTipController'

export class SectionView extends PIXI.Container {
    bg: PIXI.Graphics

    get absoluteHeight(): number {
        const absoluteHeight = this.getLocalBounds().top + this.height
        return absoluteHeight
    }

    get absoluteWidth(): number {
        const absoluteWidth = this.getLocalBounds().left + this.width
        return absoluteWidth
    }

    constructor(x: number, y: number, w: number, h: number, container?: PIXI.Container, removePadding: boolean = false) {
        super()
        const padding = removePadding ? 0 : UICanvasConfig.margin
        this.x = x + padding
        this.y = y + padding
        const newW = w - (padding * 2)
        const newH = h - (padding * 2)
        this.drawInitial(newW, newH) // We need a background otherwise PIXI.Container doesn't have height or width
        if(container != undefined) container.addChild(this)
    }

    // PIXI.Container defines height and with as the bounds of its children.
    // this.width with 1 child: https://prntscr.com/10e3atg
    // this.width with multiple children: https://prntscr.com/10e3b54
    private drawInitial(w: number, h: number) {
        this.bg = new PIXI.Graphics()
        this.bg.beginFill(0xFFFFFF)
        this.bg.drawRoundedRect(0, 0, w, h, 5)
        this.bg.endFill()
        this.bg.alpha = 0
        this.addChild(this.bg)
    }

    setTip(title: TranslationObject, bodyParagraphs: TranslationObject[]) {
        const toolTipText: ToolTipText = () => ({title: title, body: bodyParagraphs})
        uiGameManager.toolTipController.createTip(toolTipText, this)
    }
}
